module.exports = __webpack_public_path__ + "static/tuzagDesign-be7a099983924d43f58ebb5e2d61c16a.svg";